import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { Bell } from 'lucide-react';

import { formatarContagemBadge } from './apresentacao';

/**
 * Sino de notificações, com badge de contagem.
 *
 * `contagem` vem de quem o monta — nunca mockada aqui dentro: mesmo padrão do
 * badge da barra lateral (mapa.ts). Sem contagem, o badge simplesmente não
 * aparece.
 *
 * O número é texto de 10 px, então precisa de 4,5:1: usa o par
 * `destructive-foreground`/`destructive`, que a auditoria de contraste confere
 * nos quatro temas (`ui/estilos/contraste.ts`). O par `orange-foreground`/
 * `orange`, que ele usava, dava 3,14:1 no claro e 2,87:1 no escuro.
 *
 * Encaminha `ref` e o resto das props porque ele é o gatilho da gaveta
 * (`GavetaDeNotificacoes`), montado com `asChild`: sem isso o Radix não
 * consegue pendurar nele o `aria-expanded`, o `aria-controls` e o `data-state`.
 */
export const Notificacoes = forwardRef<
  HTMLButtonElement,
  { contagem?: number } & ComponentPropsWithoutRef<'button'>
>(({ contagem, ...resto }, ref) => (
  <button
    ref={ref}
    type="button"
    className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
    aria-label="Notificações"
    {...resto}
  >
    <Bell className="h-4 w-4" aria-hidden="true" />
    {contagem !== undefined && contagem > 0 && (
      <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-bold text-destructive-foreground">
        {formatarContagemBadge(contagem)}
      </span>
    )}
  </button>
));

Notificacoes.displayName = 'Notificacoes';
